import Bolao from "../../views/Admin/Bolao";
import Operador from "../../views/Admin/Usuarios/Operador";
import Rota from "../../views/Admin/Usuarios/Rota";
import Saldo from "../../views/Admin/Saldo";
import Caixa from 'views/Admin/Caixa';
import Bilhetes from 'views/Admin/Acompanhamento';
import Lancamento from 'views/Admin/Lancamento';
import ListaCaixaCambistas from "../../views/Admin/CaixaCambistas/ListaCambistas";
import Extracao from "../../views/Admin/Extracao";
import Resultado from "../../views/Admin/Resultado";
import Financeiro from "../../views/Admin/Financeiro";
import Descarga from "../../views/Admin/Descarga";
import DescargaAutomatica from "../../views/Admin/DescargaAutomatica";
import DescargaGateway from "../../views/Admin/Descarga/DescargaGateway";
import Seninha from "../../views/Admin/Seninha";
import loteriaInstantanea from "../../views/Admin/Instantanea";
import Sorteio from "../../views/Admin/Sorteio";
import Relatorio from "../../views/Admin/Relatorio";
import Regulamento from "../../views/Admin/Regulamento";
import Configuracao from "../../views/Admin/Configuracao";
import Senha from "../../views/Admin/Senha";
import Usuario from "../../views/Admin/Usuarios/Editar";
import CriarUsuario from "../../views/Admin/Usuarios/CriarUsuario";
import CriarRegulamento from "../../views/Admin/Regulamento/CriarRegulamento";
import ResumoCaixaCambistas from "../../views/Admin/CaixaCambistas/ResumoCambistas";
import AnaliseCambista from "../../views/Admin/CaixaCambistas/AnaliseCambista";
import CaixaResumo from "../../views/Admin/CaixaResumo";
import BolaoCriar from "../../views/Admin/Bolao/Criar";
import BolaoEditar from "../../views/Admin/Bolao/Editar";
import BolaoVer from "../../views/Admin/Bolao/Ver";
import Criar from "../../views/Admin/Extracao/Criar";
import Editar from "../../views/Admin/Extracao/Editar";
import Adicionar from "../../views/Admin/Resultado/Adicionar";
import CriarSorteio from "../../views/Admin/Sorteio/Criar";
import Roleta from "../../views/Admin/Roleta";
import SenaBrasil from "../../views/Admin/SenaBrasil";
import EditarConcursoSeninha from "../../views/Admin/Seninha/editar";
import EditarConcursoSenaBrasil from "../../views/Admin/SenaBrasil/editar";
import Bilhetinho from "views/Admin/Bilhetinho/index";
import BilhetinhoResultado from "views/Admin/Bilhetinho/Resultado/index";
import BilhetinhoBilhetes from "views/Admin/Bilhetinho/Bilhetes/index";
import AdicionarResultadoConcursoSeninha from "../../views/Admin/Seninha/resultado";
import AdicionarResultadoConcursoSenaBrasil from "../../views/Admin/SenaBrasil/resultado";
import {BolaoDezena} from "../../views/Admin/BolaoDezena";
import {VerBolaoDezena} from "../../views/Admin/BolaoDezena/Ver";
import AdicionarResultadoBolaoDezena from "../../views/Admin/BolaoDezena/resultado";
import {Comissao} from "../../views/Admin/Comissao";
import Rifa from "views/Admin/Rifa/index";
import Raspadinha from "views/Admin/Raspadinha/index";
import RifaResultado from "views/Admin/Rifa/Resultado/index";
import Auditoria from "../../views/Admin/Auditoria/index";
import Dashboard from "../../views/Admin/Dashboard";
import Subadmin from "../../views/Admin/Subadmin";
import Supervisores from "../../views/Admin/Supervisores";
import SupervisorCriar from "../../views/Admin/Supervisores/Criar";
import SupervisorEditar from "../../views/Admin/Supervisores/Editar";
import Promocoes from "../../views/Admin/Promocoes";
import Clientes from "../../views/Admin/Clientes";
import ClienteCriar from "../../views/Admin/Clientes/Criar";
import Contatos from "../../views/Admin/Contatos";
import ContatoCriar from "../../views/Admin/Contatos/Criar";
import Modalidades from "../../views/Admin/Modalidades";
import Cotacoes from "../../views/Admin/Cotacoes";
import EsportivasApostas from "../../views/Admin/Esportivas/Apostas";
import EsportivasCuradoria from "../../views/Admin/Esportivas/Curadoria";
import EsportivasConfiguracoes from "../../views/Admin/Esportivas/Configuracoes";
import MilharBichoRebaixado from "../../views/Admin/MilharBichoRebaixado";
import Postagem from "views/Admin/Postagem/index";
import Avisos from "views/Admin/Avisos/index";
import Suporte from "views/Admin/Suporte/index";
import Avaliacao from "../../views/Admin/Avaliacao";
import { MODULOS_2_PRA_500 } from "../../utils/modulos";

export default [
    {
        path: '/usuarios/:id/login',
        permissions: ["Listar cambista", "Listar gerente"],
        module: [],
        component: Usuario,
        showBar: false
    },
    {
        path: '/usuarios/criar/:nivel',
        permissions: ["Listar cambista", "Listar gerente"],
        module: [],
        component: CriarUsuario,
        showBar: false
    },
    {
        path: '/regulamento/criar/regulamento',
        permissions: ["Alterar regulamento"],
        module: [],
        component: CriarRegulamento,
        showBar: false
    },
    {
        path: '/caixa/resumo',
        permissions: ["Listar resumo"],
        module: [],
        component: CaixaResumo,
        showBar: false
    },
    {
        path: '/bolao/criar',
        permissions: ["Criar bolão"],
        module: [],
        component: BolaoCriar,
        showBar: false
    },
    {
        path: '/bolao/editar/:id',
        permissions: ["Criar bolão"],
        module: [],
        component: BolaoEditar,
        showBar: false
    },
    {
        path: '/bolao/:id',
        permissions: ["Ver bolão"],
        module: [],
        component: BolaoVer,
        showBar: false
    },
    {
        path: '/extracao/criar',
        permissions: ["Criar loteria"],
        module: [],
        component: Criar,
        showBar: false
    },
    {
        path: '/extracao/:id',
        permissions: ["Ver loteria"],
        module: [],
        component: Editar,
        showBar: false
    },
    {
        path: '/resultado/adicionar',
        permissions: ["Listar resultado jb"],
        module: [],
        component: Adicionar,
        showBar: false
    },
    {
        path: '/sorteio/criar',
        permissions: ["Criar sorteio"],
        module: [],
        component: CriarSorteio,
        showBar: false
    },
    // ── Routes hidden (sem sidebar) ──────────────────────────────
    { path: '/roleta', nome: 'Roleta', icon: 'fa-users', permissions: ["*"], module: [], component: Roleta, showBar: false },
    { path: '/bilhetinho/resultado', permissions: ["Listar bilhetinho"], module: [], component: BilhetinhoResultado, showBar: false },
    { path: '/bilhetinho/:id/bilhetes', permissions: ["Listar bilhetinho"], module: [], component: BilhetinhoBilhetes, showBar: false },
    { path: '/rifa/resultado', permissions: ["Listar rifa"], module: [], component: RifaResultado, showBar: false },
    { path: '/prestacao/cambistas/:id/analise', permissions: ["Listar prestação cambista"], module: [], component: AnaliseCambista, showBar: false },
    { path: '/prestacao/cambistas/:id', permissions: ["Prestação cambista"], module: [], component: ResumoCaixaCambistas, showBar: false },
    { path: '/seninha/resultado', permissions: ["Adicionar resultado seninha"], module: [], component: AdicionarResultadoConcursoSeninha, showBar: false },
    { path: '/seninha/:id', permissions: ["Listar seninha"], module: [], component: EditarConcursoSeninha, showBar: false },
    { path: '/sena-brasil/resultado', permissions: ["Adicionar resultado seninha"], module: [], component: AdicionarResultadoConcursoSenaBrasil, showBar: false },
    { path: '/sena-brasil/:id', permissions: ["Listar seninha"], module: [], component: EditarConcursoSenaBrasil, showBar: false },
    { path: '/bolao/criar', permissions: ["Criar bolão"], module: [], component: BolaoCriar, showBar: false },
    { path: '/bolao/editar/:id', permissions: ["Criar bolão"], module: [], component: BolaoEditar, showBar: false },
    { path: '/bolao/:id', permissions: ["Ver bolão"], module: [], component: BolaoVer, showBar: false },
    { path: '/bolao-dezena/resultado/:id', permissions: ["Adicionar resultado seninha"], module: [], component: AdicionarResultadoBolaoDezena, showBar: false },
    { path: '/bolao-dezena/:id', permissions: ["Listar seninha"], module: [], component: VerBolaoDezena, showBar: false },
    { path: '/raspadinha', nome: 'Raspadinha', icon: 'fa-ticket', permissions: ["Listar raspadinha"], module: ["Raspadinha"], component: Raspadinha, showBar: false, group: 'CATEGORIAS' },
    { path: '/descarga-automatica', permissions: ["Listar descarga"], module: [], component: DescargaAutomatica, showBar: false },

    // `busca`: palavras-chave opcionais da busca de menus da barra lateral, para
    // achar a tela por como as pessoas a chamam ("operador" acha Cambistas). O nome
    // e o grupo já contam sozinhos; só entra aqui o que o nome não diz.
    // ── GESTÃO ────────────────────────────────────────────────────
    { path: '/dashboard', nome: 'Dashboard', busca: ['painel', 'início', 'resumo'], icon: 'fa-pie-chart', permissions: [], module: [], nivel: ['admin'], component: Dashboard, showBar: true, group: 'GESTÃO' },
    { path: '/bilhetes', nome: 'Bilhetes', busca: ['apostas', 'pules', 'acompanhamento'], icon: 'fa-ticket', permissions: ["Listar aposta jb"], module: [], component: Bilhetes, showBar: true, group: 'GESTÃO' },
    { path: '/subadmin', nome: 'Sub Admin', busca: ['subadministrador'], icon: 'fa-user-circle', permissions: ["Criar subadmin"], module: [], component: Subadmin, showBar: true, group: 'GESTÃO' },
    { path: '/supervisores', nome: 'Grupo Gerentes', busca: ['supervisor', 'supervisores'], icon: 'fa-sitemap', permissions: [], module: [], nivel: ['admin'], component: Supervisores, showBar: true, group: 'GESTÃO' },
    { path: '/supervisores/novo', permissions: [], module: [], nivel: ['admin'], component: SupervisorCriar, showBar: false },
    { path: '/supervisores/:id/editar', permissions: [], module: [], nivel: ['admin'], component: SupervisorEditar, showBar: false },
    { path: '/rota', nome: 'Gerentes', busca: ['rota', 'usuários'], icon: 'fa-user', permissions: ["Listar gerente"], module: [], component: Rota, showBar: true, group: 'GESTÃO' },
    { path: '/', nome: 'Cambistas', busca: ['operador', 'operadores', 'vendedor', 'usuários'], icon: 'fa-users', permissions: ["Listar cambista"], module: [], component: Operador, showBar: true, group: 'GESTÃO' },
    // Clientes são operadores com tipo_usuario = cliente; mesmas permissões dos cambistas.
    { path: '/clientes', nome: 'Clientes', busca: ['cliente', 'clientes', 'usuários'], icon: 'fa-address-book', permissions: ["Listar cambista"], module: [], component: Clientes, showBar: true, group: 'GESTÃO' },
    { path: '/clientes/criar', permissions: ["Listar cambista"], module: [], component: ClienteCriar, showBar: false },
    { path: '/promocoes', nome: 'Promoções', busca: ['promoção', 'bônus'], icon: 'fa-percent', permissions: [], module: [], nivel: ['admin'], component: Promocoes, showBar: true, group: 'GESTÃO' },
    { path: '/resultado', nome: 'Resultados', busca: ['resultado do dia', 'apuração'], icon: 'fa-list-ol', permissions: ["Listar resultado jb"], module: [], component: Resultado, showBar: true, group: 'GESTÃO' },
    // Cadastro simples nome + telefone (tabela clientes), fora da barra desde 08/2026.
    { path: '/contatos', permissions: [], module: [], nivel: ['admin'], component: Contatos, showBar: false },
    { path: '/contatos/novo', permissions: [], module: [], nivel: ['admin'], component: ContatoCriar, showBar: false },
    { path: '/postagens', nome: 'Postagens', icon: 'fa-bullhorn', permissions: [], module: [], nivel: ['admin'], component: Postagem, showBar: false, group: 'GESTÃO' },

    // ── FINANCEIRO ────────────────────────────────────────────────
    { path: '/caixa', nome: 'Caixa', busca: ['fechamento'], icon: 'fa-university', permissions: ["Listar caixa"], module: [], component: Caixa, showBar: true, group: 'FINANCEIRO' },
    { path: '/prestacao/cambistas', nome: 'Prestar Contas', busca: ['prestação', 'prestação de contas', 'acerto'], icon: 'fa-calculator', permissions: ["Listar prestação cambista"], module: [], component: ListaCaixaCambistas, showBar: true, group: 'FINANCEIRO' },
    { path: '/financeiro', nome: 'Venda', busca: ['vendas', 'financeiro', 'faturamento'], icon: 'fa-area-chart', permissions: ["Listar venda"], module: [], component: Financeiro, showBar: true, group: 'FINANCEIRO' },
    { path: '/lancamento', nome: 'Lançamentos', busca: ['lançamento', 'crédito', 'débito'], icon: 'fa-credit-card-alt', permissions: ["Listar lançamento"], module: [], component: Lancamento, showBar: true, group: 'FINANCEIRO' },
    { path: '/saldo', nome: 'Saldo', busca: ['saldos', 'limite'], icon: 'fa-usd', permissions: ["Listar cambista"], module: [], component: Saldo, showBar: true, group: 'FINANCEIRO' },

    // ── LOTERIA ───────────────────────────────────────────────────
    { path: '/extracao', nome: 'Extrações', busca: ['extração', 'loterias', 'horários'], icon: 'fa-paw', permissions: ["Listar loteria"], module: ["JB"], component: Extracao, showBar: true, group: 'LOTERIA' },
    // Valor, bloqueio e ordem das apostas do Tradicional na mesma tela: são a mesma
    // lista (bancas.modalidades) e bloquear uma aposta muda o que dá para ordenar.
    { path: '/modalidades', nome: 'Modalidades', busca: ['modalidade', 'tipos de aposta', 'ordem dos tipos', 'ordenar', 'ordem das apostas'], icon: 'fa-list-alt', permissions: ["Listar modalidade"], module: ["JB"], component: Modalidades, showBar: true, group: 'LOTERIA' },
    { path: '/cotacoes', nome: 'Cotações', busca: ['cotação'], icon: 'fa-sort-numeric-asc', permissions: ["Listar cotações SENA"], module: ["JB"], component: Cotacoes, showBar: true, group: 'LOTERIA' },
    { path: '/milhar-bicho-rebaixado', nome: 'M/G Rebaixado', busca: ['milhar rebaixada', 'grupo rebaixado', 'bicho rebaixado'], icon: 'fa-level-down', permissions: [], module: [], nivel: ['admin'], component: MilharBichoRebaixado, showBar: true, group: 'LOTERIA' },
    { path: '/caixa-instantaneo', nome: 'Instantânea', busca: ['loteria instantânea', 'lucro da banca'], icon: 'fa-star', permissions: ["Alterar lucro da banca"], module: ["JB"], component: loteriaInstantanea, showBar: true, group: 'LOTERIA' },
    { path: '/relatorio', nome: 'Relatório', busca: ['relatórios'], icon: 'fa-floppy-o', permissions: ["Listar relatório"], module: [], component: Relatorio, showBar: true, group: 'LOTERIA' },
    { path: '/descarga-gateway', nome: 'Descarga', busca: ['descargas', 'gateway', 'fila'], icon: 'fa-balance-scale', permissions: ["Listar descarga"], module: ["JB"], component: DescargaGateway, showBar: true, group: 'LOTERIA' },
    { path: '/descarga', permissions: ["Listar descarga"], module: [], component: Descarga, showBar: false },

    // ── CATEGORIAS ────────────────────────────────────────────────
    { path: '/bilhetinho', nome: '2 Pra 500', busca: ['bilhetinho', '2pra500'], icon: 'fa-angellist', permissions: ["Listar bilhetinho"], module: MODULOS_2_PRA_500, component: Bilhetinho, showBar: true, group: 'CATEGORIAS' },
    { path: '/rifa', nome: 'Rifa', icon: 'fa-trophy', permissions: ["Listar rifa"], module: ["Rifa"], component: Rifa, showBar: true, group: 'CATEGORIAS' },
    { path: '/seninha', nome: 'Seninha', icon: 'fa-scribd', permissions: ["Listar seninha"], module: ["Seninha"], component: Seninha, showBar: true, group: 'CATEGORIAS' },
    { path: '/sena-brasil', nome: 'Sena Brasil', icon: 'fa-scribd', permissions: ["Listar seninha"], module: ["Sena Brasil"], component: SenaBrasil, showBar: true, group: 'CATEGORIAS' },
    { path: '/bolao-dezena', nome: 'Bolão Dezena', busca: ['bolão de dezena'], icon: 'fa-bold', permissions: ["Listar seninha"], module: ["Bolão de Dezena"], component: BolaoDezena, showBar: true, group: 'CATEGORIAS' },
    { path: '/bolao', nome: 'Bolão', icon: 'fa-bold', permissions: ["Listar bolão"], module: ["Bolão"], component: Bolao, showBar: true, group: 'CATEGORIAS' },

    // ── ESPORTIVAS (seção oculta na barra lateral por enquanto) ───
    { path: '/esportivas/apostas', nome: 'Apostas', icon: 'fa-futbol-o', permissions: ["Listar aposta esportivas"], module: ["Esportivas"], component: EsportivasApostas, showBar: false, group: 'ESPORTIVAS' },
    { path: '/esportivas/curadoria', nome: 'Catálogo', icon: 'fa-sliders', permissions: [], module: ["Esportivas"], nivel: ['admin'], component: EsportivasCuradoria, showBar: false, group: 'ESPORTIVAS' },
    { path: '/esportivas/configuracoes', nome: 'Config. Esportivas', icon: 'fa-futbol-o', permissions: [], module: ["Esportivas"], nivel: ['admin'], component: EsportivasConfiguracoes, showBar: false, group: 'ESPORTIVAS' },

    // ── ADMINISTRAÇÃO ─────────────────────────────────────────────
    { path: '/comissoes', nome: 'Comissões', busca: ['comissão', 'percentual'], icon: 'fa-percent', permissions: ["Listar modalidade"], module: [], component: Comissao, showBar: true, group: 'ADMINISTRAÇÃO' },
    { path: '/sorteio', nome: 'Sorteio', busca: ['sorteios', 'prêmio do bilhete'], icon: 'fa-gift', permissions: ["Listar sorteio"], module: [], component: Sorteio, showBar: true, group: 'ADMINISTRAÇÃO' },
    { path: '/regulamento', nome: 'Regulamento', busca: ['regras', 'regulamentos'], icon: 'fa-file-text', permissions: ["Listar regulamento"], module: [], component: Regulamento, showBar: true, group: 'ADMINISTRAÇÃO' },
    { path: '/auditoria', nome: 'Auditoria', busca: ['logs', 'histórico'], icon: 'fa-eye', permissions: ["Listar auditoria"], module: [], component: Auditoria, showBar: true, group: 'ADMINISTRAÇÃO' },
    { path: '/configuracao', nome: 'Configurações', busca: ['configuração', 'opções', 'config', 'ajustes'], icon: 'fa-cog', permissions: ["Listar opções"], module: [], component: Configuracao, showBar: true, group: 'ADMINISTRAÇÃO' },
    { path: '/avaliacao', nome: 'Avaliar o Sistema', busca: ['avaliação', 'nota'], icon: 'fa-star', permissions: [], module: [], nivel: ['admin', 'subadmin'], component: Avaliacao, showBar: true, group: 'ADMINISTRAÇÃO' },
    // Avisos da Setebit: sem permissão própria porque quem recebe já é decidido na
    // central (banca + nível) — a API só devolve o que é do usuário logado.
    { path: '/avisos', nome: 'Avisos', busca: ['aviso', 'notificações', 'comunicados'], icon: 'fa-bullhorn', permissions: [], module: [], nivel: ['admin', 'subadmin', 'socio', 'gerente'], component: Avisos, showBar: true, group: 'ADMINISTRAÇÃO' },
    // Central de ajuda escrita na central da Setebit. Sem permissão própria pelo
    // mesmo motivo dos avisos, e aberta a todos os níveis: cada tópico já declara
    // quem o vê, e a API só devolve o que é do nível do usuário logado.
    { path: '/suporte', nome: 'Suporte', busca: ['ajuda', 'central de ajuda'], icon: 'fa-life-ring', permissions: [], module: [], nivel: ['admin', 'subadmin', 'socio', 'gerente', 'operador'], component: Suporte, showBar: true, group: 'ADMINISTRAÇÃO' },
    { path: '/senha', nome: 'Senha', busca: ['alterar senha', 'trocar senha'], icon: 'fa-key', permissions: ["Alterar senha"], module: [], component: Senha, showBar: true, group: 'ADMINISTRAÇÃO' },
];
